import { authHeader } from '../helpers/auth-header';
import axios  from "../utils/axios";



const WebAppApiService = {};

WebAppApiService.editor = () => {
    return new Promise((resolve, reject) => {
        axios({
          headers: {...authHeader(),'Pragma': 'no-cache'},
          method: "get",
          url: `/api/editor`
        })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
}

export default WebAppApiService;